import { ReactNode } from 'react';
import { ReportsDashboardURLParamsProvider } from 'hooks/useReportsDashboardURLParams';
import { ReportsScreenProvider } from 'hooks/useReportsScreen';
import { ChartDashboardProvider } from './ChartDashboard/useChartDashboard';
import { InventoryDashboardProvider } from './InventoryDashboard/useInventoryDashboard';
import { PricingDashboardProvider } from './PricingDashboard/usePricingDashboard';
import { ReportsDashboardProvider } from './useReportsDashboard';
import { ReportsDashboardFiltersProvider } from './useReportsDashboardFilters';
import { ReportsDashboardRefreshProvider } from './useReportsDashboardRefresh';
import { ReportsScreenPDFProvider } from './useReportsScreenPDF';

/**
 * Wraps the reports route with the full dashboard provider stack.
 */
export const ReportsProviders = ({ children }: { children: ReactNode }) => {
  const dashboardProviders = (
    <PricingDashboardProvider>
      <InventoryDashboardProvider>
        <ChartDashboardProvider>
          <ReportsDashboardRefreshProvider>{children}</ReportsDashboardRefreshProvider>
        </ChartDashboardProvider>
      </InventoryDashboardProvider>
    </PricingDashboardProvider>
  );

  return (
    <ReportsScreenProvider>
      <ReportsDashboardProvider>
        <ReportsScreenPDFProvider>
          <ReportsDashboardFiltersProvider>
            <ReportsDashboardURLParamsProvider>{dashboardProviders}</ReportsDashboardURLParamsProvider>
          </ReportsDashboardFiltersProvider>
        </ReportsScreenPDFProvider>
      </ReportsDashboardProvider>
    </ReportsScreenProvider>
  );
};
